export enum ACTION {
  ADD = "ADD",
  EDIT = "EDIT",
  DELETE = "DELETE",
  RESET_OPERATING_TIME = "RESET_OPERATING_TIME",
  FINISH_JOB = "FINISH_JOB",
}
